import { Filter } from '@anytag/shared-molecules';
import { BasicFilter } from './BasicFilter';
import { useYoutubeCMSInvoicesFilter } from './hooks';

export const YoutubeCMSInvoicesFilter = () => {
  const { filter, setFilterForm } = useYoutubeCMSInvoicesFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <BasicFilter />
    </Filter.Provider>
  );
};
export { useYoutubeCMSInvoicesFilter };
export * from './schemaTypes';
